import { useBrowsePresetApi, useReadPresetApi } from '@aibees/shared/api';
import {
  HttpMethod,
  ParsedPreset,
  Preset,
  UpdatePresetRequest,
} from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { jsonStringify } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { PRESET_API_PREFIX } from './constants';

export function useUpdatePresetMutationApi<T = any>(
  id: string,
  invalidateDelay?: number
) {
  const workspace = useWorkspace()?.id;
  return useBaseMutation<Preset, ParsedPreset<T>, UpdatePresetRequest<T>>(
    {
      url: `${PRESET_API_PREFIX.replace(':id', String(workspace))}/${id}`,
      method: HttpMethod.patch,
    },
    {
      onMutate(variables) {
        // @ts-ignore
        variables.value = jsonStringify(variables.value) || '';
        variables.metadata = variables.metadata
          ? jsonStringify(variables.metadata) ?? undefined
          : undefined;
      },
      onSuccess: () => {
        setTimeout(() => {
          baseQueryClient.invalidateQueries([useBrowsePresetApi.name]);
          baseQueryClient.invalidateQueries([useReadPresetApi.name, id]);
        }, invalidateDelay);
      },
    }
  );
}
